import { useEffect, useState } from "react";

/**
 * 상태를 설정하면 delay 후 자동으로 초기값으로 리셋 (예: 토스트 메시지)
 */
export function useAutoClearState(initialValue, delay = 3000) {
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    if (value == null || value === initialValue) return;
    const t = setTimeout(() => setValue(initialValue), delay);
    return () => clearTimeout(t);
  }, [value, initialValue, delay]);
  return [value, setValue];
}
